import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { formatDOBFromPim } from '@mummssoftware/utils/formatters';
import { styles } from '../../utils/styles';
import { ios, safari } from '../../utils';
import defaults from '../../translations/en.json';
export const PrintHeaderPDFComponent = ({
  patient,
  browser
}) => /*#__PURE__*/React.createElement(View, {
  fixed: true,
  style: browser && browser.name === safari || browser && browser.name === ios ? styles.safariPageHeader : styles.pageHeader
}, /*#__PURE__*/React.createElement(View, {
  style: [styles.row, styles.justifyContentBetween]
}, /*#__PURE__*/React.createElement(View, {
  style: styles.row
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.printerSubHeader
}, `${patient.firstName} ${patient.lastName}, `), /*#__PURE__*/React.createElement(Text, {
  style: [styles.printerSubHeader, styles.fontWeightBold]
}, `${defaults.dob}: `), /*#__PURE__*/React.createElement(Text, {
  style: styles.printerSubHeader
}, `${patient.dateOfBirth && formatDOBFromPim(patient.dateOfBirth)}, `), /*#__PURE__*/React.createElement(Text, {
  style: [styles.printerSubHeader, styles.fontWeightBold]
}, `${defaults.patient} #: `), /*#__PURE__*/React.createElement(Text, {
  style: styles.printerSubHeader
}, `${patient.patientNumber}`)), /*#__PURE__*/React.createElement(Text, {
  style: styles.printerSubHeader
}, `${patient.hospiceName}`)));